import React from "react";
import BottomSheet from "src/components/app/BottomSheet";
import Button from "src/components/app/Button";
import Alert from "../../Alert";
import { AlertTriangle } from "lucide-react";

type Props = {
  show: boolean;
  onClose: () => void;
  onBookConsultation: () => void;
  onProceed: () => void;
};

const CGMWarningBottomSheet: React.FC<Props> = ({
  show,
  onClose,
  onBookConsultation,
  onProceed,
}) => {
  return (
    <BottomSheet
      show={show}
      title="Before you start"
      showCloseButton={true}
      handleClose={onClose}
      zIndex={70}
    >
      <div className="p-4">
        <Alert
          icon={<AlertTriangle />}
          title={
            <p>
              Failure or damage to the CGM resulting from a self-installation
              error{" "}
              <span className="font-semibold">
                cannot be covered by a refund or replacement device
              </span>
            </p>
          }
          variant="error"
        />
        <div className="flex items-center justify-between mt-4 gap-3">
          <Button
            onClick={onBookConsultation}
            variant="outlined"
            rounded="full"
            fullWidth
          >
            Book Consultation
          </Button>
          <Button
            onClick={onProceed}
            variant="contained"
            rounded="full"
            fullWidth
          >
            Connect CGM
          </Button>
        </div>
      </div>
    </BottomSheet>
  );
};

export default CGMWarningBottomSheet;
